import { render, staticRenderFns } from "./BoardingTaskPage.vue?vue&type=template&id=f891f2d4&"
import script from "./BoardingTaskPage.vue?vue&type=script&lang=js&"
export * from "./BoardingTaskPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports